import { render, staticRenderFns } from "./ActionsConversationModa.vue?vue&type=template&id=64854439&scoped=true&"
import script from "./ActionsConversationModa.vue?vue&type=script&lang=js&"
export * from "./ActionsConversationModa.vue?vue&type=script&lang=js&"
import style0 from "./ActionsConversationModa.vue?vue&type=style&index=0&id=64854439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64854439",
  null
  
)

export default component.exports